module.exports = __webpack_public_path__ + "static/media/circle-big.2c00429b.png";